import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/Limitless-BNG_WordmarkLogo.png';
import './index.scss';

const Navbar = () => {
  return (
    <nav className="navbar-component">
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/landing2" className="logo-link">
            <img src={logo} alt="Limitless Bar & Grill" className="logo-img" />
          </Link>
        </div>
        <div className="nav-links">
          <Link to="/menu" className="nav-link">Menu</Link>
          <a
            href="https://squareup.com/appointments/book/irmxmolrq6ttrb/L2072RS7486MH/start"
            target="_blank"
            rel="noreferrer"
            className="nav-link"
          >Reserve</a>
          <Link to="/new-about" className="nav-link">About</Link>
          <a href="#contact" className="nav-link">Contact</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
